export default __webpack_public_path__ + "assets/images/owner-logos_3nZRG.png";